import classNames from "classnames";
import { CSSProperties, ReactNode, useEffect, useRef } from "react";
import { When } from "react-if";
import styles from "./index.module.less";

interface SearchAssociateProps {
  data?: Array<{
    word: string;
    html: string;
  }>;
  selected: number;
  onSelect: (index: number) => void;
  preAddOn?: ReactNode;
  onSearch: (word: string, params: any) => void;
  wrapStyle?: CSSProperties;
}

/**
 * 搜索下拉框联想词
 */
export default function SearchAssociate({
  data = [],
  selected,
  onSelect,
  preAddOn = null,
  onSearch,
  wrapStyle = {},
}: SearchAssociateProps) {
  const wrapperRef = useRef(null);

  // 滚动到响应位置
  useEffect(() => {
    wrapperRef.current?.querySelector(`.${styles.active}`)?.scrollIntoView();
  }, [selected]);

  if (preAddOn === null && !data.length) {
    return null;
  }

  return (
    <div
      className={styles["associate-dropdown"]}
      id="search_dropdown"
      ref={wrapperRef}
    >
      {preAddOn}

      <When condition={preAddOn && data?.length}>
        <div className={styles.split} />
      </When>

      {data && data.length ? (
        <>
          <ul className={styles.associate} style={wrapStyle}>
            {data.map(({ word, html }, index) => (
              <li
                key={word}
                className={classNames({ [styles.active]: selected === index })}
                onMouseOver={() => {
                  if (index === selected) return;
                  onSelect(index);
                }}
                dangerouslySetInnerHTML={{
                  __html: html,
                }}
                onClick={() => {
                  onSearch(word, {
                    type: "联想搜索词",
                  });
                }}
              />
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
}
